import React from 'react';
import { Badge, Button } from 'antd';
import { CaretRightOutlined, StopOutlined } from '@ant-design/icons';
import { ColumnProps } from 'antd/lib/table';
import { IScheduleListItem } from '../../../hooks/backend/api/usePackagesApi';

type TColumnProps = ColumnProps<IScheduleListItem>;

interface IScheduleListColumnsParams {
  onDisableClick(id: string): Promise<void>;
  onEnableClick(id: string): Promise<void>;
  disablingSchedules: string[];
  enablingSchedules: string[];
}

export const ScheduleListColumns = (props: IScheduleListColumnsParams): TColumnProps[] => {
  return [
    {
      title: 'Дата',
      key: 'date',
      render: (text, record) => (
        <Badge
          status={record.disabled ? 'default' : 'success'}
          text={record.date}
        />
      )
    },
    {
      title: 'Действие',
      key: 'action',
      width: 180,
      render: (text, record) => record.disabled ? (
        <Button
          block
          icon={<CaretRightOutlined />}
          loading={props.enablingSchedules.indexOf(record.id) >= 0}
          onClick={() => props.onEnableClick(record.id)}
        >
          Включить
        </Button>
      ) : (
        <Button
          block
          icon={<StopOutlined />}
          loading={props.disablingSchedules.indexOf(record.id) >= 0}
          onClick={() => props.onDisableClick(record.id)}
        >
          Отключить
        </Button>
      )
    }
  ];
};
